import { HTTP } from '@/CallAPI'
import CircularJSON from 'circular-json'
export default {
  getMenu () {
    return HTTP.get('menus')
  },
  getMenuOfGroup (groupName) {
    return HTTP.get('menus/' + groupName)
  },
  updateMenu (data, group) {
    return HTTP.post('menus', {
      data: CircularJSON.stringify(data),
      group_id: group.id
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/menu.js